import { useQuery } from '@tanstack/react-query';
import { certificateService } from '../services/certificateService';
import { useEffect } from 'react';

export function useCertificates() {
  console.log('🔍 [CERTIFICATES] Hook called at:', new Date().toISOString());

  const result = useQuery({
    queryKey: ['certificates'],
    queryFn: async () => {
      console.log('🔍 [CERTIFICATES] QueryFn EXECUTING at:', new Date().toISOString());
      const data = await certificateService.getCertificates();
      console.log('🔍 [CERTIFICATES] QueryFn RESULT:', data);
      return data;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always', // Changed to 'always' string value
    refetchOnWindowFocus: false,
    retry: 1,
    retryDelay: 1000,
  });

  useEffect(() => {
    console.log('🔍 [CERTIFICATES] Hook state changed:', {
      data: result.data,
      isLoading: result.isLoading,
      isFetching: result.isFetching,
      isError: result.isError,
      error: result.error,
      status: result.status,
      fetchStatus: result.fetchStatus,
    });
  }, [result.data, result.isLoading, result.isFetching, result.status, result.fetchStatus]);

  return result;
}
